const maxFileSizeMB = 100;
export const maxFileSizeBytes = 1024 * 1024 * maxFileSizeMB;
